import { mixed, number, object } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const minutesDurationValidationSchema = ({ min = 1, max = 720 } = {}) => number()
  .typeError(I18n.t('errors.messages.not_a_number'))
  .required()
  .integer()
  .min(min, I18n.t(
    'errors.messages.greater_than_or_equal_to',
    { count: `${min} ${I18n.t('time.min_abbr')}` }
  ))
  .max(max, I18n.t(
    'errors.messages.less_than_or_equal_to',
    { count: `${max} ${I18n.t('time.min_abbr')}` }
  ))

const hoursDurationValidationSchema = () => number()
  .typeError(I18n.t('errors.messages.not_a_number'))
  .required()
  .positive(I18n.t(
    'errors.messages.greater_than_or_equal_to',
    { count: `1 ${I18n.t('time.min_abbr')}` }
  ))
  .max(12, I18n.t(
    'errors.messages.less_than_or_equal_to',
    { count: `12 ${I18n.t('time.hours_abbr.one')}` }
  ))

const customDurationValidationSchema = ({ minutes: { min = 1, max = 720 } = {} } = {}) => mixed()
  .when(['eventDuration', 'customEventDurationType'], {
    is: (duration, type) => duration === 'custom' && type === 'minutes',
    then: minutesDurationValidationSchema({ min, max })
  })
  .when(['eventDuration', 'customEventDurationType'], {
    is: (duration, type) => duration === 'custom' && type === 'hours',
    then: hoursDurationValidationSchema()
  })
  .test('isDivisibleByMinutes', I18n.t('errors.messages.invalid'), (value, { parent }) => {
    const { eventDuration: duration, customEventDurationType: type } = parent
    if (duration === 'custom' && type === 'hours' && value !== undefined) {
      return Number.isInteger(value * 60.0)
    }
    return true
  })

const tempCustomDurationValidationSchema = ({ minutes: { min = 1, max = 720 } = {} } = {}) => mixed()
  .when(['isCustomDurationOpen', 'tempCustomEventDurationType'], {
    is: (isOpen, type) => isOpen && type === 'minutes',
    then: minutesDurationValidationSchema({ min, max })
  })
  .when(['isCustomDurationOpen', 'tempCustomEventDurationType'], {
    is: (isOpen, type) => isOpen && type === 'hours',
    then: hoursDurationValidationSchema()
  })
  .test('isDivisibleByMinutes', I18n.t('errors.messages.invalid'), (value, { parent }) => {
    const { isCustomDurationOpen: isOpen, tempCustomEventDurationType: type } = parent
    if (isOpen && type === 'hours' && value !== undefined) {
      return Number.isInteger(value * 60.0)
    }
    return true
  })

export const getValidationSchema = () => object({
  customEventDuration: customDurationValidationSchema(),
  tempCustomEventDuration: tempCustomDurationValidationSchema()
})
